import loadable from '@loadable/component';

export const OrgDashboardRepostEventPageContainerLoadable = loadable(
  () => import('./OrgDashboardRepostEventPageContainer'),
  {
    resolveComponent: (module) => module.OrgDashboardRepostEventPageContainer,
    ssr: false,
  },
);
